export const BASE_URL = process.env.VUE_APP_BASE_URL;